import React from "react";
import "./ValtraLoadingButton.scss";

const ValtraLoadingButton = React.memo(
  ({ label, loading, loaded, loadingProgress, className, ...rest }) => {
    return (
      <div
        className={
          "ValtraLoadingButton" +
          (loading ? " loading" : "") +
          (loaded ? " loaded" : "")
        }
        {...rest}
      >
        <div
          className="ValtraLoadingButton_indicator"
          style={{ width: `${100 * loadingProgress}%` }}
        />
        <div className="ValtraLoadingButton_label">{label}</div>
      </div>
    );
  }
);

export default ValtraLoadingButton;
